import { render, staticRenderFns } from "./RetailSetting.vue?vue&type=template&id=48fa0daa&scoped=true"
import script from "./RetailSetting.vue?vue&type=script&lang=js"
export * from "./RetailSetting.vue?vue&type=script&lang=js"
import style0 from "./RetailSetting.vue?vue&type=style&index=0&id=48fa0daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa0daa",
  null
  
)

export default component.exports